import React from 'react';
import axios from 'axios';
import { Button, Modal, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import '../../App.css';

var WydrukMagazyn = React.createClass({

	getInitialState: function() {
		return {
			wydrukMagazyn: {
				id: '',
				cena: '',
				czyZdjecie: '',
				grubosc: '',
				hdf: '',
				kosztUslugi: '',
				lustro: '',
				numerListwy: '',
				numerPass: '',
				operator: '',
				punktSprzedazy: '',
				szerokosc: '',
				szklo: '',
				uwagi: '',
				wysokosc: '',
				zawieszka: '',
				dataZlozenia: '',
				imie: '',
				nazwisko: '',
				telefon: '',
				pozostalaDoplata: '',
				dataOdbioru: '',
				czyPass: '',
			}
		}
    },

		render: function() {

			return (
				<Modal show={this.props.parent.state.showWydrukMagazynModal}>
					<Modal.Header>
						<Modal.Title>Wydruk dla Magazynu - Zlecenie nr {this.state.wydrukMagazyn.id}</Modal.Title>
					</Modal.Header>
					<Modal.Body id= 'printable' >
					<div>
          <table>
					<tbody>
            <tr>
              <th>Data: </th>
              <th>{this.state.wydrukMagazyn.dataZlozenia}</th>
              <th>Numer zamówienia: </th>
              <th>{this.state.wydrukMagazyn.id}</th>
            </tr>
            <tr>
              <td rowSpan="4">Nazwisko: </td>
              <td rowSpan="4">{this.state.wydrukMagazyn.nazwisko}</td>
              <td>Listwa: </td>
              <td>{this.state.wydrukMagazyn.numerListwy}</td>
            </tr>
            <tr>
              <td>Szkło: </td>
              <td>{this.state.wydrukMagazyn.szklo}</td>
            </tr>
            <tr>
              <td>HDF: </td>
              <td>{this.state.wydrukMagazyn.hdf ? 'TAK' : 'NIE'}</td>
            </tr>
            <tr>
              <td>Zawieszka: </td>
              <td>{this.state.wydrukMagazyn.zawieszka ? 'TAK' : 'NIE'}</td>
            </tr>
            <tr>
              <td rowSpan="2">Telefon: </td>
              <td rowSpan="2">{this.state.wydrukMagazyn.telefon}</td>
              <td>Lustro: </td>
              <td>{this.state.wydrukMagazyn.lustro ? 'TAK' : 'NIE'}</td>
            </tr>
            <tr>
              <td>Passe partout: </td>
              <td>{this.state.wydrukMagazyn.numerPass}</td>
            </tr>
            <tr>
              <td>Data odbioru: </td>
              <td>{this.state.wydrukMagazyn.dataOdbioru}</td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td colSpan="2">Uwagi: </td>
              <td colSpan="2">Podpis: </td>
            </tr>
            <tr>
              <td colSpan="2">{this.state.wydrukMagazyn.uwagi}</td>
              <td colSpan="2">Można zrobić zdjęcie: {this.state.wydrukMagazyn.czyZdjecie ? 'TAK' : 'NIE'}</td>
            </tr>
						<tr>
							<td colSpan="2">Punkt sprzedaży: </td>
							<td colSpan="2">{this.state.wydrukMagazyn.punktSprzedazy}</td>
						</tr>
						<tr>
							<td colSpan="2">Punkt sprzedaży: {this.state.wydrukMagazyn.punktSprzedazy}</td>
							<td colSpan="2">Sprzedawca: {this.state.wydrukMagazyn.operator}</td>
						</tr>
						</tbody>
          </table>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<Button onClick={this.props.parent.closeWydrukMagazynModal}>Zamknij</Button>
						<Button bsStyle="primary" onClick={this.onDrukujBtnClicked}>Drukuj</Button>
					</Modal.Footer>
				</Modal>
			);
		},

	fillWydrukMagazynObject: function() {
    	var selectedZlecenie = this.props.parent.getZlecenieById(this.props.parent.state.selectedZlecenieId);

		  this.state.wydrukMagazyn = {
			id: selectedZlecenie.id,
			cena: selectedZlecenie.cena,
			czyZdjecie: selectedZlecenie.czyZdjecie,
			grubosc: selectedZlecenie.grubosc,
			hdf: selectedZlecenie.hdf,
			kosztUslugi: selectedZlecenie.kosztUslugi,
			lustro: selectedZlecenie.lustro,
			numerListwy: selectedZlecenie.numerListwy,
			numerPass: selectedZlecenie.numerPass,
			operator: selectedZlecenie.operator,
			punktSprzedazy: selectedZlecenie.punktSprzedazy,
			szerokosc: selectedZlecenie.szerokosc,
			szklo: selectedZlecenie.szklo,
			uwagi: selectedZlecenie.uwagi,
			wysokosc: selectedZlecenie.wysokosc,
			zawieszka: selectedZlecenie.zawieszka,
			dataZlozenia: selectedZlecenie.dataZlozenia,
			imie: selectedZlecenie.imie,
			nazwisko: selectedZlecenie.nazwisko,
			telefon: selectedZlecenie.telefon,
			pozostalaDoplata: selectedZlecenie.pozostalaDoplata,
			dataOdbioru: selectedZlecenie.dataOdbioru,
			czyPass: selectedZlecenie.czyPass,
		}
	},

	clearWydrukMagazynObject: function() {
		this.state.wydrukMagazyn.id = '';
		this.state.wydrukMagazyn.imie = '';
		this.state.wydrukMagazyn.nazwisko = '';
		this.state.wydrukMagazyn.telefon = '';
		this.state.wydrukMagazyn.numerListwy = '';
		this.state.wydrukMagazyn.szerokosc = '';
		this.state.wydrukMagazyn.wysokosc = '';
		this.state.wydrukMagazyn.grubosc = '';
		this.state.wydrukMagazyn.cena = '';
		this.state.wydrukMagazyn.numerPass = '';
		this.state.wydrukMagazyn.szklo = '';
		this.state.wydrukMagazyn.hdf = '';
		this.state.wydrukMagazyn.kosztUslugi = '';
		this.state.wydrukMagazyn.lustro = '';
		this.state.wydrukMagazyn.operator = '';
		this.state.wydrukMagazyn.uwagi = '';
		this.state.wydrukMagazyn.punktSprzedazy = '';
		this.state.wydrukMagazyn.czyZdjecie = '';
		this.state.wydrukMagazyn.zawieszka = '';
		this.state.wydrukMagazyn.dataZlozenia = '';
		this.state.wydrukMagazyn.pozostalaDoplata = '';
		this.state.wydrukMagazyn.dataOdbioru = '';
		this.state.wydrukMagazyn.czyPass = '';
	},

	onDrukujBtnClicked: function() {
		this.printDiv('printable');

    this.sleep(3000).then(() => {
        window.location.reload(true);
    });

},

sleep: function(time) {
  return new Promise((resolve) => setTimeout(resolve, time));
},

 printDiv: function(divName){
			var printContents = document.getElementById(divName).innerHTML;
			var originalContents = document.body.innerHTML;

      document.body.innerHTML = printContents;
			window.print();
		}

});

export default WydrukMagazyn;



// WEBPACK FOOTER //
// ./src/components/Zlecenie/WydrukMagazyn.js